import { Config } from '../../config'

export const bsiConfig: Config = {
  partner: 'bsi',
  catalog: 'partner',
  displayName: 'BSI',
  accentColor: '#253d88',
  host: 'seating.bsilab.com',
}
